<div class="dialog-container" id="surs-reciprocal-report-modal">
  <div class="header-title">Generate SURS Reciprocal Report</div>
  <form [formGroup]="formGroup" (ngSubmit)="onGenerate()">
    <div class="form-container">
      <div class="input-container">
        <div class="input-group">
          <ptg-datepicker
            [controlField]="formGroup.get('benefitBeginDate')"
            placeholder="Benefit Begin Date"
            class="input-benefit-begin-date"
            [isRequired]="true"
            errorRequire="Benefit Begin Date is required"
          ></ptg-datepicker>
        </div>
        <div class="input-group">
          <ptg-datepicker
            [controlField]="formGroup.get('benefitEndDate')"
            placeholder="Benefit End Date"
            class="input-benefit-end-date"
            [isRequired]="true"
            errorRequire="Benefit End Date is required"
          ></ptg-datepicker>
        </div>
      </div>
      <div *ngIf="isGenerating" class="processing-message">
        <mat-spinner diameter="30"></mat-spinner>
        <span>Processing report...</span>
      </div>
    </div>
    <div class="row-button">
      <button 
        class="submit-button" 
        mat-raised-button 
        type="submit"
        [disabled]="isGenerating"
      >
        Generate Report
      </button>
      <button 
        (click)="onCancel()" 
        class="cancel-button" 
        mat-raised-button 
        type="button"
        [disabled]="isGenerating"
      >
        Cancel
      </button>
    </div>
  </form>
</div>
